import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/bytedance/Desktop/gatsby/src/components/BlogLayout/index.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`我是真的没想到，退出网文江湖后还能有被催更的时候。加了微信的，微信催更。没加微信的，公众号后台留言催更。`}</p>
    <p>{`催更的多是生活文。`}</p>
    <p>{`仔细想了想，技术本身是枯燥的，纵然有心雕琢，巧夺天工仍是不如鬼斧神工来的自在纯粹。`}</p>
    <p>{`加之受众问题，技术文我其实很少会发朋友圈，空间之类的。特定技术平台，特定人群，我佛系写，有缘人观之即可。`}</p>
    <p>{`我想尽可能保持技术文不掺杂过多的个人情感，直抒胸臆自然是好，但也应该区分场景。强行杂糅多元素，倒是有些舍本逐末，不伦不类了。`}</p>
    <p>{`也许不是不喜欢，表白也要有个合适的契机，对吧？`}</p>
    <p>{`默默地说一句，我确实是一个技术博主。`}</p>
    <p>{`与只在床下说话算数的世子殿下不同，躺在床上写文的我也是极为认真的。`}</p>
    <p>{`仔细想了想，生活文确实有它独特的魅力。`}</p>
    <p>{`魅力在哪？`}</p>
    <p>{`平湖秋月，偶有蜻蜓点水。落叶沾襟，撩拨起层层涟漪。微风一笑抚细柳，皓月低眉水中游。以动带静，以静衬动。`}</p>
    <p>{`这，就是魅力。`}</p>
    <p>{`技术文没有的江湖气，生活文可以有。技术文有的小知识点，生活文还会有。`}</p>
    <p>{`至于写哪种，完全随心吧。当然，我尽可能保持一个平衡。`}</p>
    <p>{`至于一碗水能不能端平，不好说，但无妨。`}</p>
    <p>{`握不住的沙，扬了便是。端不平的水，喝了便是。还能补充身体水分，何乐而不为呢？`}</p>
    <p>{`若说为难别人是错，那为难自己便是错上加错。切莫偏差理解，法外狂徒张三也有溺水而亡的时候。生活应该越来越有盼头，而不是判头。`}</p>
    <p>{`听君一席话，胜坐十年牢。`}</p>
    <p>{`满纸荒唐言，一把辛酸泪？`}</p>
    <p>{`非也，吾之落笔，绝无半分荒唐，也无任何心酸。坦诚清晰是主脉络，谈喜避忧是原则，我可不想把负面情绪传递出去。`}</p>
    <p>{`这种事，把阿絮拎过来一阵猛撸就好。我的猫，吃我的，喝我的，摸摸狗头怎么了？`}</p>
    <p>{`吃的比我都好，锁个喉还要记仇，当真是小气。至于见到我就跑？`}</p>
    <p>{`近来诸事繁多，持续迭代的业务需求，个人思维拓展与技术提升，所以，就只好佛系更文啦。`}</p>
    <p>{`还是那句话，很开心你能来，不遗憾你离开。我并不关心粉丝是怎么来的，也不在意是怎么没的。`}</p>
    <p>{`我能做到的是，没特殊情况不会弃更，但也不会忙着更文影响正常生活和工作。`}</p>
    <p>{`至于软文广告，接是不可能接的。也许会有真香的时候，但绝不会是现在。倒不是什么清高之举，只是觉得我还没写过瘾，不想掺杂什么利益因素，那会影响我的思绪。`}</p>
    <p>{`最难的是不忘初心，得不得始终另说，我倒是，挺喜欢这种我手写我心的感觉。`}</p>
    <p>{`思如泉涌，落笔成河，倒也乐的自在。`}</p>
    <p>{`最近看了两集云顶天宫，心态炸了，我是真没想到能拍成这个鬼样子。`}</p>
    <p>{`屁股着地张起开？`}</p>
    <p>{`神情呆滞张起开？`}</p>
    <p>{`双眼无神张起开？`}</p>
    <p>{`十年之约等个这玩意？青铜门里待着吧你，回什么家？`}</p>
    <p>{`我甚至怀疑，这部剧是拿出来衬托同行的。相比之下，杨洋，成毅，肖宇梁的张起灵足以封神。`}</p>
    <p>{`本是心有千千结，不忍苦离别，如今看了只觉离谱二字深入脑海，久久挥之不去。`}</p>
    <p>{`离谱，简直离天下之大谱。`}</p>
    <p>{`罢了罢了，此事不再提。`}</p>
    <p>{`仔细想想，断断续续写文也有几年光阴了。越是坚持，越能看到不一样的风景。`}</p>
    <p>{`最近重温《雪中悍刀行》，白狐脸儿听潮亭的雪中刀，当真是技术活。`}</p>
    <p>{`骑鹤下江南，解签为红衣的骑牛道士洪洗象。下山便是天下第一，规矩再大，大不过其身后剑。`}</p>
    <p>{`江南好，最好是红衣。`}</p>
    <p>{`送君千里，终须一别。`}</p>
    <p>{`希望每一个小读者能喜欢我，的文。`}</p>
    <p>{`时间差不多了，要去搬砖。`}</p>
    <p>{`情如风雪无常,`}</p>
    <p>{`却是一动即殇。`}</p>
    <p>{`感谢你这么好看还来阅读我的文章,`}</p>
    <p>{`我是冷月心,下期再见。`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      